module.exports = __webpack_public_path__ + "img/c4.ce701130.png";